import {css, StyleSheet} from "aphrodite";
import React from 'react';
import Config from "../config/Config";
import MediaQuery from "../styles/MediaQuery";

const FeedbackButton = ({extraStyle, header, text}) => {
    const styles = StyleSheet.create({
        container: {
            backgroundColor: Config.colors.FEEDBACK_BUTTON,
            color: Config.colors.SECONDARY_TEXT,
            borderRadius: header ? 20 : 32,
            fontSize: header ? 13 : 15,
            lineHeight: header ? 1.54 : 1.8,
            letterSpacing: 0.2,
            padding: header ? "10px 30px" : "13px 40px 12px 40px",
            textAlign: "center",
            fontWeight: "bold",
            textTransform: "uppercase",
            width: "max-content",
            height: "fit-content",
            display: "grid",
            alignItems: "center",
            ':hover': {
                cursor: "pointer",
                backgroundColor: Config.colors.FEEDBACK_BUTTON_HOVER,
                transition: "background-color 0.1s cubic-bezier(0.4, 0, 0.2, 1) 0s"
            },
            ...MediaQuery.mobile(header ? {
                fontSize: 12,
                lineHeight: 1.67,
                letterSpacing: 0.18,
                padding: "9px 20px 7px 20px"
            } : {
                padding: "13px 30px 12px 30px"
            })
        }
    });

    function openDownloadLink() {
        return window.open(Config.resources.DOWNLOAD[getOS()], "_blank")
    }

    return (
        <div className={css(styles.container, extraStyle)} onClick={openDownloadLink}>
            {text || Config.messages.downloadNow}
        </div>
    );
};

export default FeedbackButton;

function getOS() {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'mac';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'ios';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'windows';
    } else if (/Android/.test(userAgent)) {
        os = 'android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'linux';
    }

    return os;
}
